import { User } from "../../../data/model/user-model"

export const AuthActionTypes = {
    API_ATTEMPT: "@@auth/API_ATTEMPT",
    API_SUCCESS: "@@auth/API_SUCCESS",
    API_FAILURE: "@@auth/API_FAILURE",

    SET_USER: "@@auth/SET_USER",
    SET_TOKEN: "@@auth/SET_TOKEN",
    CLEAR_TOKEN: "@@auth/CLEAR_TOKEN",
    SET_PENDING_ACTION: "@@auth/SET_PENDING_ACTION",
    LOGIN: "@@auth/LOGIN"
}

export interface AuthToken {
    readonly access_token: string | null
    readonly id_token: string | null
    readonly refresh_token: string | null
}

export interface AuthState extends AuthToken {
    loading: boolean
    errorMessage: string
    readonly user: User | null
}

export interface LoginPayload {
    username: string
    password: string
    disableRedirect?: boolean
    code?: string
}

export interface ErrorResponse {
    error: string
    error_description: string
    message: string
    status: string
}

export interface TokenResponse extends AuthToken, ErrorResponse {
    expires_in: number
    scope: string
    token_type: string
}

export interface UserResponse extends ErrorResponse {
    userId: string
    roles: string[]
    userEmail?: string // on prem field
    email?: string // SMRT Link Cloud field
    firstName?: string
    lastName?: string
}

export const RoleMapping = {
    "Internal/PbAdmin": "Admin",
    "Internal/PbLabTech": "Lab Tech",
    "Internal/PbBioinformatician": "Bioinformatician",
    "Internal/PbInstrument": "Instrument",
    // for V2 API (Keycloak) we don't have the prefix any more
    "PbAdmin": "Admin",
    "PbLabTech": "Lab Tech",
    "PbBioinformatician": "Bioinformatician",
    "PbInstrument": "Instrument"
}
